import './style.css'
import logo from "./images/logo.png"
import SelectorInputCity from './SelectorInputCity'
import SelectorInputLocal from './SelectorInputLocal'
import SelectorInputShop from './SelectorInputShop'
import { auth, db } from "./FireBase"
import Select from 'react-select';
import DatePicker from "react-datepicker";


import { dbRef, dbRefDevice } from './FireBase';
import { useEffect, useState } from 'react';

import { ref, set, child, onValue } from "firebase/database";
import { createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

import { LineChart } from "./LineChart.tsx"
import { LineChartCount } from './lineChartCount.tsx'

import DataRange from './DataRange.js'


function Admin({ userCred, isLoggedIn, setIsLoggedIn }) {

  const [allData, setAllData] = useState([])

  const [devices, setDevices] = useState([])

  const [cities, setCities] = useState([])
  const [selectedCities, setSelectedCities] = useState([])

  const [locals, setLocals] = useState([])
  const [selectedLocals, setSelectedLocals] = useState([])

  const [shops, setShops] = useState([])
  const [selectedShop, setSelectedShop] = useState([])

  const [userLocations, setUserLocations] = useState(null)
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [dataRange, setDataRange] = useState({ "start": new Date(), "end": new Date(), "option": 0 })

  const [isCustomRange, setIsCustomRange] = useState(false);

  const [errorModal, setErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successModalMessage, setSuccessModalMessage] = useState(false);

  const [selectedTimeProfit, setSelectedTimeProfit] = useState(0)
  const [selectedTimeCount, setSelectedTimeCount] = useState(0)

  const [devicesForMin, setDevicesForMin] = useState(null)
  const [minTime, setMinTime] = useState(null)
  const [selectedRole, setSelectedRole] = useState(null)
  const [countryOption, setCountryOption] = useState([])
  const [userCountry, setUserCountry] = useState(null)


  useEffect(() => {
    onValue(dbRefDevice, (snapshot) => {
      if (snapshot.exists()) {
        setDevicesForMin(Object.entries(snapshot.val()))
      }
    })
  }, [])

  useEffect(() => {
    // if ()
    let timeStamps = []
    devicesForMin?.forEach((device) => {
      if (device[1]?.Button1?.Timestamp != undefined && device[1]?.Button2?.Timestamp != undefined) {
        Object.values(device[1]?.Button1?.Timestamp).forEach((timeStamp) => timeStamps.push(timeStamp?.Ts))
        Object.values(device[1]?.Button2?.Timestamp).forEach((timeStamp) => timeStamps.push(timeStamp?.Ts))
      }
    })
    function getSmallestNumber(numbers) {
      let smallest = numbers[0];
      for (let i = 1; i < numbers.length; i++) {
        if (numbers[i] < smallest) {
          smallest = numbers[i];
        }
      }
      return smallest;
    }
    let min = getSmallestNumber(timeStamps)

    setMinTime(min)
  }, [devicesForMin])


  useEffect(() => {
    setStartDate(dataRange.start)
    setEndDate(dataRange.end)
    // console.warn("++++++++++", dataRange.start, dataRange.end)
  }, [dataRange])

  useEffect(() => {
    if (startDate > endDate) {
      setErrorModalMessage('Start Date cannot be bigger than End Date')
      setErrorModal(true)
      setStartDate(new Date(new Date() - new Date(2502152000)))
      setEndDate(new Date())
    }
  }, [startDate, endDate])



  let tempCities = []

  const [users, setUsers] = useState()
  useEffect(() => {
    if (isLoggedIn == "user" || isLoggedIn == "owner") {
      const dbRefUser = child(ref(db), `users/` + `${userCred?.uid}`);
      onValue(dbRefUser, (snapshot) => {

        if (snapshot.exists()) {
          setUsers(Object.entries(snapshot.val()))
        } else {
        }
      })
      // }
    }

  }, [userCred])
  useEffect(() => {
    if (isLoggedIn == "admin") {
      const dbRefCountries = child(ref(db), `valid-countries/`);
      onValue(dbRefCountries, (snapshot) => {

        if (snapshot.exists()) {
          let countOptions = []
          for (const [key, value] of Object.entries(snapshot.val())) {
            countOptions.push({ "value": key, "label": value })
            // console.log(`${key}: ${value}`);
          }
          setCountryOption(countOptions)
        } else {
        }
      })
      // }
    }

  }, [userCred])
  const [locations, setLocations] = useState([])
  useEffect(() => {
    // let locations = []
    //console.error("is", isLoggedIn)
    onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        if (isLoggedIn == "admin") {
          setLocations(Object.entries(snapshot.val()))
        } else if (isLoggedIn == "owner" && users && users[0][1]) {
          let locationsIdsOfOwner = Object.keys(users[0][1]);
          let dummy = Object.entries(snapshot.val()).filter((loc) => locationsIdsOfOwner.includes(loc[0]))
          setLocations(dummy)
        } else if (isLoggedIn == "user" && users && users[0][1]) {
          // setUserLocations(locations)
          let locationsIdsOfUser = Object.keys(users[0][1])
          let dummy = Object.entries(snapshot.val()).filter((loc) => locationsIdsOfUser.includes(loc[0]))
          //console.log("locationsOfUser", locationsIdsOfUser, locations, dummy)
          setLocations(dummy)
        }
      } else {
        //console.log("not")
      }

      onValue(dbRefDevice, (snapshot) => {
        if (snapshot.exists()) {
          setDevices(Object.entries(snapshot.val()))

        } else {
        }

      })
    })
  }, [users, isLoggedIn])

  useEffect(() => {
    // let locationsOfUser = Object.keys(users[0][1])

    if (locations && locations[0]) {
      tempCities = []
      locations.forEach((location) => {
        if (!tempCities.includes(`${location[1].country}`) && location[1].country != undefined) {
          tempCities.push(location[1].country)
        } else {

        }

        setCities(tempCities)
        setAllData(locations)
      })
    }
  }, [locations])


  // let [test, setTest] = useState(0)
  //   setInterval(() => {
  //     setTest(++test)
  //   }, 1000)
  //   useEffect(() => {

  //   }, [test])

  useEffect(() => {
    if (selectedCities.length > 0) {
      let tempLocals = []
      // console.warn("selectedCities", selectedCities, allData)
      selectedCities.forEach((selectedCity) => {
        allData.forEach((data) => {
          if (selectedCity.value == (`${data[1].country}`)) {
            tempLocals.push(data[1].city)
          } else {

          }
        })

      })
      let uniqeLocal = []
      // // console.warn(tempLocals)
      tempLocals.forEach((local) => {
        if (!uniqeLocal.includes(local)) {
          uniqeLocal.push(local)
          // // console.warn(uniqeLocal)

        }
      })
      setLocals(uniqeLocal)
    } else {
      setSelectedLocals([])
      setLocals([])
    }
  }, [selectedCities, allData])

  // useEffect(() => {
  //   // console.warn(ci)
  // }, [cities])
  useEffect(() => {
    if (selectedLocals.length > 0) {
      let tempLocals = []

      selectedLocals.forEach((selectedLocal) => {
        allData.forEach((data) => {
          if (selectedLocal.value == (`${data[1].city}`)) {
            tempLocals.push({ id: data[1].location_id, name: data[1].location_name })
          } else {
            // // console.log(data[1].country, selectedCities)
          }
        })

      })

      setShops(tempLocals)
    } else {
      setShops([])
      setSelectedShop([])
    }
  }, [selectedLocals, allData])

  const [x, setX] = useState([])

  const [totalButton1State, setTotalButton1State] = useState(0)
  const [totalButton2State, setTotalButton2State] = useState(0)
  const [profit, setProfit] = useState()
  const [selectedDatasState, setSelectedDataState] = useState()
  const [selectedDevicesState, setSelectedDevicesState] = useState()
  const [selectedRevenueShare, setSelectedRevenueShare] = useState()
  const [selectedTotalRevenue, setSelectedTotalRevenue] = useState()
  const [selectedTotalProfit, setSelectedTotalProfit] = useState()


  useEffect(() => {
    // // console.log(selectedShop)
    let selectedShopsStocks = []
    let shopsStocks = []
    // console.error(selectedShop)

    const calcStocks = () => {
      // console.log(allData)
      let revenue_share = 0
      let total_revenue = 0;
      let total_profit = 0;
      selectedShop.forEach((shop) => {
        let stocks = allData.filter(data => data[1].location_id == shop.value)
        // // console.warn("stocks", stocks)
        let coffeeStock = 0
        let delightStock = 0
        let sugarStock = 0
        // // console.warn(stocks)
        if (stocks[0][1].total_revenue) {
          total_revenue += stocks[0][1].total_revenue;
        }

        if (stocks[0][1].revenue_share) {
          revenue_share += stocks[0][1].revenue_share;
        }
        //  [Total Revenue_loc1]*[(100-revenue_share_loc1)/100] 
        // + [Total Revenue_loc2]*[(100-revenue_share_loc2)/100] 
        // + [Total Revenue_locN]*[(100-revenue_share_locN)/100]

        total_profit += total_revenue * ((100 - revenue_share) / 100);

        setSelectedTotalRevenue(total_revenue);
        setSelectedRevenueShare(revenue_share);
        setSelectedTotalProfit(total_profit);
        if (stocks.length && stocks[0].length > 0 && stocks[0][1].stocks) {
          Object.entries(stocks[0][1].stocks).forEach((stock) => {
            // // console.log(stock[1].coffee)
            coffeeStock += stock[1].coffee
            delightStock += stock[1].delight
            sugarStock += stock[1].sugar

            // // console.warn(coffeeStock)

          })
          shopsStocks.push({ id: shop.value, stocks: { coffe: coffeeStock, delight: delightStock, sugar: sugarStock } })
          // // console.warn(shopsStocks)
          selectedShopsStocks.push(shopsStocks)

        }
      })
    }

    const calcTotalRevenue = () => {

      let selectedDatasDevicesListString = []

      selectedShop.forEach((shop) => {
        let selectedDatas = allData.filter(data => data[1].location_id == shop.value)

        if (selectedDatas[0] && selectedDatas[0][1].devices) {
          // console.warn("selectedDatas", selectedDatas, Object.keys(selectedDatas[0][1].devices))
          selectedDatasDevicesListString.push(Object.keys(selectedDatas[0][1].devices))
        } else {
          setTotalButton1State(0)
          setTotalButton2State(0)
          return
        }



      })
      setSelectedDevicesState(selectedDatasDevicesListString)

      // console.warn(Object.values(selectedDatasDevicesListString))
      let totalButton1 = 0
      let totalButton2 = 0
      if (Object.values(selectedDatasDevicesListString).length > 0) {
        // console.warn("devices", devices)
        let selectedDevicesObject = []
        devices.forEach((device) => {
          // console.log("224", selectedDatasDevicesListString)
          let selectedDevicesArr = []
          selectedDatasDevicesListString.forEach((item) => {
            item.forEach((inItem) => {
              selectedDevicesArr.push(inItem)
            })
          })
          // console.log("helloooooo", selectedDevicesArr, device[0])

          selectedDevicesArr.forEach((item) => {

            if (item.includes(`${device[0]}`)) {
              //console.log("innnnnnnn")
              // console.warn(Object.keys(device[1].Button1.Timestamp).length)
              // console.warn("device", device[0])
              // totalButton1 = totalButton1 + (Object.keys(device[1].Button1.Timestamp).length)
              // totalButton2 = totalButton2 + (Object.keys(device[1].Button2.Timestamp).length)

              if (device[1].Button1 && !device[1].Button2) {
                selectedDevicesObject.push({ id: device[0], btn1: Object.keys(device[1].Button1.Timestamp).length, btn2: 0 })
              }
              else if (device[1].Button2 && !device[1].Button1)
                selectedDevicesObject.push({ id: device[0], btn1: 0, btn2: Object.keys(device[1].Button2.Timestamp).length })
              else if (!device[1].Button2 && !device[1].Button1)
                selectedDevicesObject.push({ id: device[0], btn1: 0, btn2: 0 })
              else
                selectedDevicesObject.push({ id: device[0], btn1: Object.keys(device[1].Button1.Timestamp).length, btn2: Object.keys(device[1].Button2.Timestamp).length })
              // console.warn("totalsState", totalButton1State, totalButton2State, Object.keys(device[1].Button1.Timestamp).length)
              // console.warn(totalButton1, totalButton2, "totals")

            }
          })
        })
        //console.warn("selectedDevicesObject", selectedDevicesObject)
        let bt1Count = 0
        let btn2Count = 0
        selectedDevicesObject.forEach((object) => {
          //console.warn(object)
          bt1Count += object.btn1
          btn2Count += object.btn2
        })

        //console.log(btn2Count, bt1Count)
        setTotalButton1State(bt1Count)
        setTotalButton2State(2 * btn2Count)
        // setTotalButton1State(totalButton1)
        // setTotalButton2State(totalButton2)
      }



      // console.warn("total2", totalButton1State)
      let sumOfSale = 0
      let tempAllSelectedDatas = []
      selectedShop.forEach((shop) => {
        let selectedDatas = allData.filter(data => data[1].location_id == shop.value)
        tempAllSelectedDatas.push(selectedDatas)
        // console.warn(selectedDatas)
        let sellPriceOfSelectedShop = 0
        if (selectedDatas && selectedDatas[0] && selectedDatas[0][1]) {
          sellPriceOfSelectedShop = selectedDatas[0][1].sell_price
        }
        setSelectedDataState(tempAllSelectedDatas)
        sumOfSale += (sellPriceOfSelectedShop * (totalButton1State + totalButton2State))
        // console.warn("sumOfSale", sumOfSale)
        // console.log(sumOfSale, selectedShop, selectedDatas, sellPriceOfSelectedShop, totalButton1State, totalButton2State)
      })
      setProfit(sumOfSale)
    }

    // // console.warn(shopsStocks)
    setX(selectedShopsStocks)
    if (allData.length > 0) {
      allData.forEach((data) => {
        // console.log(data[1].stocks, data[1].location_id)
      })
      calcStocks()
      calcTotalRevenue()
      // // console.log("selectedShopsStocks", selectedShopsStocks)
    }
  }, [selectedShop, devices, allData, totalButton1State, totalButton2State])


  function addSubUser() {
    if (subUserNameInput.length == 0 || subUserEmailInput.length == 0) {
      setErrorModalMessage('Email and Name Surname cannot be empty.')
      setErrorModal(true)
      return
    }
    console.log(selectedRole)

    const date = new Date()
    createUserWithEmailAndPassword(auth, subUserEmailInput, "123456").then((userCredential) => {
      let selectedLocationForNewUser = {}
      sendPasswordResetEmail(auth, subUserEmailInput).then(() => {
          // console.log('userCredential.user.uid', userCredential.user.uid)
        if (isLoggedIn == "admin" && selectedRole != null) {
          if (selectedRole == "Admin") {
            const dbRefAdmins = child(ref(db), `admins/` + `${userCredential.user.uid}`);
            set((dbRefAdmins), true);
          }
          if (selectedRole == "Technician") {
            const dbRefTechnicians = child(ref(db), `technicians/` + `${userCredential.user.uid}`);
            set((dbRefTechnicians), true);
          }
          const dbRefUserCreds = child(ref(db), `usersCreds/` + `${userCredential.user.uid}`);
          set((dbRefUserCreds), {
            email: `${userCredential.user.email}`,
            uid: `${userCredential.user.uid}`,
            registerTime: date.getTime(),
            Role: selectedRole,
            NameAndSurname: subUserNameInput,
            Country: userCountry
          })
        }
        else {
          Object.keys(selectedShop).forEach(shop => {
            selectedLocationForNewUser[selectedShop[shop].value] = true;
            const dbRefLocationsUsers = child(ref(db), `locations/` + `${selectedShop[shop].value}/` + "users/" + `${userCredential.user.uid}`);
            set((dbRefLocationsUsers), {
              valid: true,
              Role: "Subuser",
              NameAndSurName: subUserNameInput
            })
          })
          const dbRefUsers = child(ref(db), `users/` + `${userCredential.user.uid}`);
          set((dbRefUsers), {
            valid: true,
            locations: selectedLocationForNewUser
          })
          const dbRefUserCreds = child(ref(db), `usersCreds/` + `${userCredential.user.uid}`);
          set((dbRefUserCreds), {
            email: `${userCredential.user.email}`,
            uid: `${userCredential.user.uid}`,
            registerTime: date.getTime(),
            Role: "Subuser"
          })
        }
        setSuccessModal(true)
        setSubUserEmailInput('')
        setSubUserNameInput('')

      }).catch((error) => {
          console.log(error)
          // setErrorModal(true)
      });
    }).catch((e) => {
      setErrorModalMessage('Email in use.')
      setErrorModal(true)
    })
  }

  const [inComplete, setInComplete] = useState(0)
  const [allInComplete, setAllInComplete] = useState(0)

  useEffect(() => {
    let selectedInComplete = []
    selectedShop.forEach((shop) => {
      allData.forEach(data => {
        if (data[1].location_id == shop.value && data[1].incomplete_ids) {
          if (Object.values(data[1].incomplete_ids).length > 1) {
            Object.values(data[1].incomplete_ids).forEach((item) => {
              selectedInComplete.push(item)
            })
          } else {
            selectedInComplete.push(Object.values(data[1].incomplete_ids)[0])
          }
        }
      })

    })
    selectedInComplete.forEach((item) => console.error(item.timestamp))

    let allInComplete = []
    let finalIncomplete = []
    selectedInComplete.forEach((item) => {
      if (item.timestamp >= startDate.getTime() && item.timestamp <= endDate.getTime()) {
        finalIncomplete.push(item.timestamp)
      } else console.error(item.timestamp, startDate.getTime())

      allInComplete.push(item.timestamp)
    })
    console.error(selectedInComplete, finalIncomplete)


    setAllInComplete(allInComplete.length)
    setInComplete(finalIncomplete.length)
  }, [selectedShop, startDate, endDate])


  const [totalStocks, setTotalStocks] = useState()
  let totalCoffe = 0
  let totalDelight = 0
  let totalSugar = 0
  useEffect(() => {
    if (x.length > 0) {
      // // console.log("x", x[0][0])

      x[0].forEach((a) => {
        totalCoffe = totalCoffe + a.stocks.coffe
        totalDelight = totalDelight + a.stocks.delight
        // // console.log(a.stocks)
      })
      setTotalStocks([totalCoffe, totalDelight])
    }


  }, [x])

  useEffect(() => {
    // // console.log("*************************************************", allData)
    if (allData.length > 0) {
      // // console.warn(allData)
    } else {
      // // console.warn(allData)
    }
  }, [allData])

  useEffect(() => {
    // console.warn("devices", devices)
  }, [devices])


  // SIGN OUT ==============================================================================================

  const signOut = () => {
    setIsLoggedIn("false")
    sessionStorage.clear()
  }

  const showChartsBoxes = () =>{
    window.location.reload()
    // const subUserPage = document.getElementById("subUserPage");
    // const dataBoxWrapper = document.getElementById("counters");
    // const chartWrapperWrapper = document.getElementById("chartWrapperWrapper");
    // if (subUserPage.style.display === "block") {
    //   subUserPage.style.display = "none";
    //   dataBoxWrapper.style.display = "flex";
    //   chartWrapperWrapper.style.display = "flex";
    // }
  }
  const openAddSubUserPage = () => {
    const subUserPage = document.getElementById("subUserPage");
    const dataBoxWrapper = document.getElementById("counters");
    const chartWrapperWrapper = document.getElementById("chartWrapperWrapper");
    if (subUserPage.style.display === "block") {
      subUserPage.style.display = "none";
      dataBoxWrapper.style.display = "flex";
      chartWrapperWrapper.style.display = "flex";
    } else {
      subUserPage.style.display = "block";
      dataBoxWrapper.style.display = "none";
      chartWrapperWrapper.style.display = "none";
    }
  };

  function formatNumber(num) {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 10000) {
      return (num / 1000).toFixed(1) + 'K';
    } else {
      return num;
    }
  }

  const [subUserNameInput, setSubUserNameInput] = useState('');
  const [subUserEmailInput, setSubUserEmailInput] = useState('');

  const handleSubUserEmailInput = (event) => {
    setSubUserEmailInput(event.target.value);
  }

  const handleSubUserNameInput = (event) => {
    setSubUserNameInput(event.target.value);
  }

  function handleToggleUserClick(userId, locationId, isValid) {

    const dbRefLocationsUsersToggle = child(ref(db), `locations/` + `${locationId}/` + "users/" + `${userId}/` + "valid");
    set((dbRefLocationsUsersToggle), !isValid)

    // console.log(`User ID: ${userId}, Location ID: ${locationId}`);
  }
  const handleAddSubUser = () => {
    let options = [{ value: "all", label: `All` }]
    shops.forEach((shop) => {
      options.push({ value: `${shop.id}`, label: `${shop.name}` })
    })
    setSelectedShop(options.slice(1, options.length))
  }
  function getSubUsersAndNames() {
    const selectedShopIds = selectedShop.map(obj => (obj.value));
    const locationAndSubusers = [];
    locations.forEach(loc => {
      if (selectedShopIds.includes(loc[1].location_id)) {
        let users = loc[1].users;
        
        let userObj = Object.keys(users).map(user => ({
          id: user, names: users[user].NameAndSurName, isValid: users[user].valid, Role: users[user].Role
        }))
        // console.log(userObj)
        locationAndSubusers.push({ locationId: loc[0], locationName: loc[1].location_name, users: userObj });

      }
    })
    return (
      <table border="1">
        <thead>
          <th>UID</th>
          <th>Name and surname</th>
          <th>Location name</th>
          <th>Role</th>
          <th>Delete user</th>
        </thead>
        <tbody>
        {locationAndSubusers.map((location, index) => (
          location.users.map((user, index) => (
            <tr>
              {/* UID */}
              <td>{user.id}</td>
              {/* Name and surname */}
              <td>{user.names ? (
                    <div className={`subUserName ${user.isValid ? 'fillGreen' : 'fillGrey'}`} >{user.names}</div>
                    ) : <div class='fillGreen'>ADMIN</div>}</td>
              {/* Location name */}
              <td>{location.locationName}</td>
              {/*Role  */}
              <td>
              {user.names &&
                  // user.isValid && (<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><path d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"/></svg>)
                  user.Role
                }
              </td>
              <td>{user.names ? (
              <a href="#"
              class="test1"
              onClick={() =>
                handleToggleUserClick(user.id, location.locationId, user.isValid)
              }
            ><span><svg class='fillRed' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" /></svg></span>
            </a>): ""}
            {user.names ? (
                <a href="#"
                  onClick={() =>
                    handleToggleUserClick(user.id, location.locationId, user.isValid)
                  }
                  class="test1">
                  {user.isValid ? <span style={{marginLeft:"15px"}}><svg class='fillGrey' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z" /></svg></span> : <span style={{marginLeft:"15px"}}><svg class='fillGreen' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg></span>}
                </a>) : ""}
              </td>
            </tr>
          ))
        ))} 
        </tbody>
      </table>
      
      // <div class="data--box">
      //   {locationAndSubusers.map((location, index) => (
      //     <div class="data-box" key={index}>
      //       <h2>{location.locationName}</h2>
      //       <ul>
      //         {location.users.map((user, index) => (

      //           <li key={index} class="subUserNameLine">
                  
      //             {user.names ? (
      //               <div className={`subUserName ${user.isValid ? 'fillGreen' : 'fillGrey'}`} >{user.names}</div>
      //             ) : <div class='fillGreen'>ADMIN</div>}
      //             {user.names ? (
      //               <div class="subUserName--a">
      //                 <a
      //                   href="#"
      //                   onClick={() =>
      //                     handleToggleUserClick(user.id, location.locationId, user.isValid)
      //                   }
      //                   class="test1">
      //                   {user.isValid ? <span><svg class='fillGrey' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z" /></svg></span> : <span><svg class='fillGreen' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg></span>}
      //                 </a>
      //                 <a
      //                   href="#"
      //                   class="test1"
      //                   onClick={() =>
      //                     handleToggleUserClick(user.id, location.locationId, user.isValid)
      //                   }
      //                 >
      //                   <span><svg class='fillRed' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" /></svg></span>
      //                 </a>
      //               </div>
      //             ) : ''}
      //           </li>
      //         ))}
      //       </ul>
      //     </div>
      //   ))}
      // </div>
    );
  }
  const valueChanged = (value) => {
    setSelectedRole(value.value)

  }
  const countryOptionChange = (value) => {
    setUserCountry(value.value)

  }
  return (
    <div className="App">
      {/* <CallLocationsData setCities={setCities} allData={allData} setAllData={setAllData} />
      <CallDevicesData setDevices={setDevices} /> */}
      <div id="myModal" className={errorModal ? "modal fade show" : "modal fade"}>
        <div className="modal-dialog modal-confirm">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="m330 768 150-150 150 150 42-42-150-150 150-150-42-42-150 150-150-150-42 42 150 150-150 150 42 42Zm150 208q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Zm0-60q142 0 241-99.5T820 576q0-142-99-241t-241-99q-141 0-240.5 99T140 576q0 141 99.5 240.5T480 916Zm0-340Z" /></svg>
              <button type="button" className="close" onClick={() => setErrorModal(false)} data-dismiss="modal" aria-hidden="true">&times;</button>
            </div>
            <div className="modal-body text-center">
              <h4>Error Occured!</h4>
              <p>{errorModalMessage}</p>
              <button className="btn btn-success" onClick={() => setErrorModal(false)} data-dismiss="modal">Try Again</button>
            </div>
          </div>
        </div>
      </div>

      <div id="myModal" className={successModal ? "modal success fade show" : "modal success fade"}>
        <div className="modal-dialog modal-confirm">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z" /></svg>
              <button type="button" className="close" onClick={() => setSuccessModal(false)} data-dismiss="modal" aria-hidden="true">&times;</button>
            </div>
            <div className="modal-body text-center">
              <h4>Great!</h4>
              <p>New profile added successfully.</p>
              <button className="btn btn-success" onClick={() => setSuccessModal(false)} data-dismiss="modal">Ok</button>
            </div>
          </div>
        </div>
      </div>

      {/* <div id="modal" className={`error ${errorModal}`}>
        <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 96 960 960" width="40"><path d="M479.988 776q15.012 0 25.179-10.155 10.166-10.155 10.166-25.167 0-15.011-10.155-25.178-10.155-10.166-25.166-10.166-15.012 0-25.179 10.155-10.166 10.154-10.166 25.166t10.155 25.178Q464.977 776 479.988 776Zm-31.321-155.333h66.666V372h-66.666v248.667ZM480.177 976q-82.822 0-155.666-31.5t-127.178-85.833Q143 804.333 111.5 731.44 80 658.546 80 575.667q0-82.88 31.5-155.773Q143 347 197.333 293q54.334-54 127.227-85.5Q397.454 176 480.333 176q82.88 0 155.773 31.5Q709 239 763 293t85.5 127Q880 493 880 575.823q0 82.822-31.5 155.666T763 858.544q-54 54.21-127 85.833Q563 976 480.177 976Zm.156-66.666q139 0 236.001-97.334 97-97.333 97-236.333t-96.875-236.001q-96.876-97-236.459-97-138.667 0-236 96.875Q146.666 436.417 146.666 576q0 138.667 97.334 236 97.333 97.334 236.333 97.334ZM480 576Z" /></svg>
        <p>Start date bigger than end date!</p>
        <button onClick={() => setErrorModal(false)}>Okey</button>
      </div> */}
      <div id="page-wrapper">
        <header>
          <div onClick={showChartsBoxes} className="brand-logo">
            <img src={logo}></img>
          </div>
          {(isLoggedIn == "admin" || isLoggedIn == "owner") && (<div onClick={openAddSubUserPage} className='header-boxes addSubUserPageButton'>
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" /></svg>
            {/* <img onClick={signOut} src={logOutRed}></img> */}
          </div>)
          }

          <div onClick={signOut} className='header-boxes logout-button'>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" /></svg>
            {/* <img onClick={signOut} src={logOutRed}></img> */}
          </div>

        </header>

        <div>

          <div className="selection-container">



          </div>
          <div id="data-container">
            <div className='admin-labels-wrapper'>
              <div className='label--selector'>
                <label>Country</label>
                <SelectorInputCity users={users} isLoggedIn={isLoggedIn} cities={cities} setCities={setCities} locations={locations} setSelectedCities={setSelectedCities} selectedCities={selectedCities} />
              </div>
              <div className='label--selector'>
                <label>City</label>
                <SelectorInputLocal users={users} isLoggedIn={isLoggedIn} locals={locals} setSelectedLocals={setSelectedLocals} />
              </div>
              <div className='label--selector'>
                <label>Venue</label>
                <SelectorInputShop users={users} isLoggedIn={isLoggedIn} shops={shops} setSelectedShop={setSelectedShop} selectedShop={selectedShop} />
              </div>
              <div className="custom--selector-wrapper">
                <div className="label--selector">
                  <label>Data Range</label>
                  <DataRange minTime={minTime} dataRange={dataRange} setDataRange={setDataRange} setIsCustomRange={setIsCustomRange} />
                </div>
                {
                  isCustomRange ?
                    <div id='datePickerWrapper'>
                      <div>
                        <label>Start Date</label>
                        <div id='bar'></div>
                        <DatePicker className="datePicker" id='startDatePicker' selected={startDate} onChange={(date) => setStartDate(date)} />
                      </div>
                      <div>
                        <label>End Date</label>
                        <div id='bar'></div>
                        <DatePicker className="datePicker" id='endDatePicker' selected={endDate} onChange={(date) => setEndDate(date)} />
                      </div>
                    </div> :
                    null
                }
              </div>
            </div>


            <div id="subUserPage">
              <div id="subUserPageInputWrapper">
                <div class="input--field">
                  <div class="label--addSubUserInput">Email</div><input type='text' value={subUserEmailInput} className="addSubUserInput" onChange={handleSubUserEmailInput} />
                </div>
                <div class="input--field">
                  <div class="label--addSubUserInput">Name Surname</div><input type='text' value={subUserNameInput} className="addSubUserInput" onChange={handleSubUserNameInput} />
                </div>
                {isLoggedIn == "admin" && (
                  <>
                    <div class="input--field">
                      <div class="label--addSubUserInput custom-controls">Role</div><Select styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          minHeight: "44px"
                        }),
                      }} id='job-selector' options={[{ "value": "Admin", "label": "Admin" }, { "value": "Technician", "label": "Technician" }]} onChange={valueChanged} />
                    </div>
                    <div class="input--field">
                      <div class="label--addSubUserInput custom-controls">Country</div><Select styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          minHeight: "44px"
                        }),
                      }} id='job-selector' options={countryOption} onChange={countryOptionChange} />
                    </div>
                  </>
                )}

                <button onClick={addSubUser} class="btn" type='addSubUsers'>Add User</button>

              </div>
              {/* <div id="subUserPageInputWrapper">
                <input type='text' value={subUserNameInput} className="addSubUserInput searchBar"  placeholder='Search User By UID (User Id from Firebase Authentication)'/>
              </div> */}
              <div className='usersContainer'>
                {
                  getSubUsersAndNames()
                }
              </div>

            </div>

            <div className='admin-labels-wrapper' id="counters">
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p style={{color:"red"}}>Total sessions</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p style={{color:"red"}}>Total cost</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p>Total cups sold</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p style={{color:"red"}}>Sessions sold</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p style={{color:"red"}}>Single cups sold</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p style={{color:"red"}}>Revenue of single cups</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M220 976q-23 0-41.5-18T160 916V236q0-23 18.5-41.5T220 176h580v60H693v60q0 14-12.5 27T654 336H368q-14 0-26.5-13T329 296v-60H220v680h188q-38-26-58.5-63T329 763V570h364v193q0 53-21 90t-59 63h187v60H220Zm290.5-86q51.5 0 87-37.042Q633 815.917 633 763V630H389v133q0 52.917 35 89.958Q459 890 510.5 890Zm-.5-394q16.575 0 27.787-11.213Q549 473.575 549 457t-11.213-27.787Q526.575 418 510 418t-27.788 11.213Q471 440.425 471 457t11.212 27.787Q493.425 496 510 496Zm1 134Z" /></svg>
                  <div>
                    <p style={{color:"red"}}>Revenue of sessions</p>
                    {
                      x.length ?
                        <>
                          <p>{totalStocks ? `${selectedTimeCount - inComplete}` : null}</p>
                          <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{((selectedTimeCount - inComplete) * 0.008).toFixed(2)}</b> kg</p>
                        </> :
                        <p>-</p>
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 576 512" width="48"><path d="M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z" /></svg>
                  <div>
                    <p>Total revenue (€)</p>
                    {
                      x.length ?
                        <p>{totalStocks ? `${formatNumber(Math.round(selectedTimeProfit))}` : null}</p> :
                        <p>-</p>
                    }
                    
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="60" viewBox="0 96 960 960" width="60"><path d="M480 618 270 828q-9 9-21 9t-21-9q-9-9-9-21t9-21l210-210-210-210q-9-9-9-21t9-21q9-9 21-9t21 9l210 210 210-210q9-9 21-9t21 9q9 9 9 21t-9 21L522 576l210 210q9 9 9 21t-9 21q-9 9-21 9t-21-9L480 618Z" /></svg>
                  <div>
                    <p>Incomplete</p>
                    {
                      x.length ?
                        <p>{inComplete}</p> :
                        <p>-</p>
                    }
                    {
                      isLoggedIn != "user" ?
                        <p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}>{"Undefined "}{<b style={{ color: "#000" }}>{allInComplete}</b>}{" sessions"}</p> :
                        null
                    }
                  </div>
                </div>
              </div>
              <div className='label--selector'>
                <div className='data-box'>
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M160 936v-60h639v60H160Zm151-120q-63 0-107-43.5T160 666V216h660q24.75 0 42.375 17.625T880 276v160q0 24.75-17.625 42.375T820 496h-96v170q0 63-44 106.5T573 816H311Zm0-60h261.978Q609 756 636.5 728.5T664 666V276H220v390q0 35 28 62.5t63 27.5Zm413-320h96V276h-96v160Zm-282 80Z" /></svg>
                  <div>
                    <p>Total cups/Coffee stock</p>
                    {
                      x.length ?
                        // <p>{totalStocks ? formatNumber(((totalStocks[0] - selectedTimeCount) / 8)- (selectedTimeCount - inComplete))  : null}</p> :
                        <p>{totalStocks ? formatNumber(Math.round(((totalStocks[0] - selectedTimeCount) / 8) - (selectedTimeCount - inComplete))) : null}</p> :
                        <p>-</p>
                    }
                    {
                      x.length ?
                        <p>{totalStocks ? (<p style={{ textAlign: "right", fontSize: "13px", color: "#9a9a9a" }}><b style={{ color: "#000" }}>{Math.round(((((totalStocks[0] - selectedTimeCount) / 8) - (selectedTimeCount - inComplete)) * 0.008) * 10) / 10}</b> kg</p>) : null}</p> :
                      <p>-</p>
                    }
                  </div>
                </div>
              </div>

            </div>
            <div id='chartWrapperWrapper'>
              <div id="chartWrapper">
                <LineChart selectedTimeProfit={selectedTimeProfit} setSelectedTimeProfit={setSelectedTimeProfit} isCustomRange={isCustomRange} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} x={x} devices={devices} selectedDatasState={selectedDatasState} selectedDevicesState={selectedDevicesState} selectedShop={selectedShop} />
              </div>
              <div id="chartWrapper">
                <LineChartCount selectedTimeCount={selectedTimeCount} setSelectedTimeCount={setSelectedTimeCount} isCustomRange={isCustomRange} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} x={x} devices={devices} selectedDatasState={selectedDatasState} selectedDevicesState={selectedDevicesState} selectedShop={selectedShop} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Admin;